import React from "react";

export default function LoginCard({ children }) {
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col text-left mb-6 pb-2 border-b border-slate-200">
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
          Giriş
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Hesabınıza giriş yapın
        </p>
      </div>
      {children}
    </div>
  );
}
